import { useContext } from 'react';
import GuiContext from 'config/context/guiContext';

const GuiVersion = ({ color, size }) => {
    const {
        userData: { version },
    } = useContext(GuiContext);
    return (
        <span
            style={{
                color: color ? color : "#FFFFFF",
                fontSize: size ? size : "12px"
            }}
        >
            v2.4.1
        </span>

    )
}

export default GuiVersion;